<script>
  export let color="white";
</script>
<svg width="15px" height="15px" version="1.1" style="fill:{color}" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
 <path d="m79.242 100h-58.484c-2.0859 0-3.7734-1.6875-3.7734-3.7734v-38.113c0-2.0859 1.6875-3.7734 3.7734-3.7734h3.7734v-16.148c0-14.066 11.402-25.469 25.473-25.469 14.066 0 25.469 11.402 25.469 25.469v16.148h3.7734c2.0859 0 3.7734 1.6875 3.7734 3.7734v38.109c0 2.0898-1.6914 3.7773-3.7773 3.7773zm-15.762-61.055c0-7.4453-6.0352-13.48-13.48-13.48s-13.48 6.0352-13.48 13.48v15.395h26.965v-15.395z"/>
</svg>
